<template>
  <div>
    <span class="header-dropdown-profile-username">{{ user && user.username }}</span>
    <mdb-dropdown>
      <mdb-btn
        slot="toggle"
        size="sm"
        icon="user"
        rounded
        color="lightblue"
        title="View profile"
      />
      <mdb-dropdown-menu dropleft>
        <mdb-btn
          @click="logout"
          size="sm"
          type="button"
          rounded
          gradient="sunny-morning"
          class="float-right"
          title="Log out current user"
        >Log out</mdb-btn>
      </mdb-dropdown-menu>
    </mdb-dropdown>
  </div>
</template>

<script>
import { mdbDropdown, mdbDropdownToggle, mdbDropdownMenu, mdbIcon, mdbBtn, mdbInput } from 'mdbvue'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'HeaderDropdownProfile',
  computed: {
    ...mapState('user', {
      user: state => state.user
    })
  },
  methods: {
    ...mapActions('user', ['authLogout']),
    ...mapActions('calc', ['setClient']),
    logout () {
      this.setClient(null)
      this.authLogout().then(() => {
        if (this.$route.path !== '/calc') {
          this.$router.push('/')
        }
      })
    }
  },
  components: {
    mdbDropdown,
    mdbDropdownToggle,
    mdbDropdownMenu,
    mdbIcon,
    mdbBtn,
    mdbInput
  }
}
</script>

<style lang="sass">
.header-dropdown-profile-username
  color: darkblue
</style>



// WEBPACK FOOTER //
// src/components/HeaderDropdownProfile.vue